/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import PaginasEspecificas from '../../../../components/paginasEspecificas';

function Paradoxos() {
  return (
    <PaginasEspecificas posicao="15" endereco="/fisica" materia="Física" />
  );
}

export default Paradoxos;
